import { ligainicial } from './rutainicial';
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";

export const licitaciones2026 = [
    {
        // CONVOCATORIA NUM# 038
        'numConvocatoria' : 'Convocatoria No. 038/2026.',
        'idConvocatoria' : 'Convocatoria38',
        'procedimientos' : [
            // Licitación N116
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N116-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de agosto al 4 de septiembre de 2026',
                'descripcionProcedimiento' : 'Mantenimiento de Cuartel del Arte.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligasipdus }38/N116/N116.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }38/N116/JAN116.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }38/N116/APN116.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }38/N116/FAN116.pdf`,
                    //    },
                ],
            },
            // Licitación N115
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N115-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de agosto al 4 de septiembre de 2026.',
                'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de los Mercados Municipales San Bartolo Tutotepec; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }38/N115/N115.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }38/N115/JAN115.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }38/N115/APN115.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }38/N115/FAN115.pdf`,
                    //    },
                ],
            },
            // Licitación N114
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N114-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de agosto al 4 de septiembre de 2026.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico ubicado en la cabecera municipal de Singuilucan; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }38/N114/N114.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }38/N114/JAN114.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }38/N114/APN114.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }38/N114/FAN114.pdf`,
                    //    },
                ],
            },
            // Licitación N113
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N113-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 24 de agosto al 4 de septiembre de 2026.',
                'descripcionProcedimiento' : 'Centro Turístico multifuncional "Los Lavaderos", centro histórico Mineral del Chico; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }38/N113/N113.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }38/N113/JAN113.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }38/N113/APN113.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }38/N113/FAN113.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 037
        'numConvocatoria' : 'Convocatoria No. 037/2026.',
        'idConvocatoria' : 'Convocatoria37',
        'procedimientos' : [
            // Licitación N112
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N112-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. Agua Blanca-Zacualpa (tercera etapa); en el municipio de Agua Blanca de Iturbide.; ubicada en Varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N112/N112.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N112/JAN112.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N112/APN112.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N112/FAN112.pdf`,
                       },
                ],
            },
            // Licitación N111
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N111-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Andrés Quintana Roo, El Salto, municipio de Epazoyucan.; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N111/N111.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N111/JAN111.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N111/APN111.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N111/FAN111.pdf`,
                       },
                ],
            },
            // Licitación N110
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N110-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle de acceso al plantel CECYTEH, en el municipio de Francisco I. Madero.; ubicada en la localidad de San Juan Tepa, Municipio de Francisco I. Madero, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N110/N110.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N110/JAN110.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N110/APN110.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N110/FAN110.pdf`,
                       },
                ],
            },
            // Licitación N109
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N109-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación hidráulica en Av. Javier Rojo Gómez, en el municipio de Huichapan.; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N109/N109.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N109/JAN109.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N109/APN109.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N109/FAN109.pdf`,
                       },
                ],
            },
            // Licitación N108
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N108-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Sur 110, El Cerrito, municipio de Zempoala.; ubicada en la localidad de El Cerrito de Téllez, Municipio de Zempoala, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N108/N108.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N108/JAN108.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N108/APN108.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N108/FAN108.pdf`,
                       },
                ],
            },
            // Licitación N107
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N107-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación integral de calle Constitución, en cabecera municipal, en el municipio de Villa de Tezontepec.; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N107/N107.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N107/JAN107.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N107/APN107.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N107/FAN107.pdf`,
                       },
                ],
            },
            // Licitación N106
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N106-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de auditorio municipal de usos múltiples, primera etapa, en el municipio de Ixmiquilpan.; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }37/N106/N106.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N106/JAN106.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N106/APN106.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }37/N106/FAN106.pdf`,
                       },
                ],
            },
            // Licitación N105
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N105-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 17 al 31 de agosto de 2026.',
                'descripcionProcedimiento' : 'Encauzamiento y saneamiento del río Chinguiñoso, en el municipio de Huejutla de Reyes; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }37/N105/N105.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }37/N105/JAN105.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }37/N105/APN105.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }37/N105/FAN105.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 036
        'numConvocatoria' : 'Convocatoria No. 036/2026.',
        'idConvocatoria' : 'Convocatoria36',
        'procedimientos' : [
            // Licitación N104
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N104-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026',
                'descripcionProcedimiento' : 'Terminación de pavimentación de concreto asfáltico en calle Campo de Tiro, colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo(Segundo Procedimiento)',
                'urlAnexos' : `${ ligasipdus }36/N104/N104.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }36/N104/JAN104.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }36/N104/APN104.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }36/N104/FAN104.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 035
        'numConvocatoria' : 'Convocatoria No. 035/2026.',
        'idConvocatoria' : 'Convocatoria35',
        'procedimientos' : [
            // Licitación N103
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N103-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026',
                'descripcionProcedimiento' : 'Construcción de colector pluvial y acceso en la avenida Calzada Periférica, Cd. Sahagún municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }35/N103/N103.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N103/JAN103.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N103/APN103.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N103/FAN103.pdf`,
                       },
                ],
            },
            // Licitación N102
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N102-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Reconstrucción de la avenida Corredor Industrial Norte, en la Zona Industrial Cd. Sahagún; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }35/N102/N102.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N102/JAN102.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N102/APN102.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N102/FAN102.pdf`,
                       },
                ],
            },
            // Licitación N101
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N101-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Demolición y Construcción de Edificación Multifuncional, ubicado en Calle Parque Hidalgo No. 182 Col. Centro, Pachuca de Soto,Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N101/N101.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N101/JAN101.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N101/APN101.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N101/FAN101.pdf`,
                       },
                ],
            },
            // Licitación N100
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N100-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de C.E. La Estancia - Pacula, tramo La Estancia - Potreritos, en el municipio de Zimapán.; ubicada en la localidad de Ex-Hacienda la Estancia, Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N100/N100.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N100/JAN100.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N100/APN100.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N100/FAN100.pdf`,
                       },
                ],
            },
            // Licitación N99
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N99-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimentación asfáltica de la carretera Almoloya a entronque de acceso a la localidad de Rancho Nuevo, en el municipio de Almoloya.; ubicada en la localidad de Rancho Nuevo, Municipio de Almoloya, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N99/N99.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N99/JAN99.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N99/APN99.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N99/FAN99.pdf`,
                       },
                ],
            },
            // Licitación N98
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N98-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Río Yaqui, colonia ISSSTE, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N98/N98.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N98/JAN98.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N98/APN98.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N98/FAN98.pdf`,
                       },
                ],
            },
            // Licitación N97
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N97-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Av. Hombres Ilustres barrio Mexiquito, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N97/N97.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N97/JAN97.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N97/APN97.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N97/FAN97.pdf`,
                       },
                ],
            },
            // Licitación N96
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N96-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 10 al 21 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Río Nautla, colonia ISSSTE, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }35/N96/N96.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }35/N96/JAN96.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }35/N96/APN96.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }35/N96/FAN96.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 034
        'numConvocatoria' : 'Convocatoria No. 034/2026.',
        'idConvocatoria' : 'Convocatoria34',
        'procedimientos' : [
            // Licitación N95
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N95-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 7 de agosto de 2026',
                'descripcionProcedimiento' : 'Infraestructura complementaria del complejo "Hidalgo Honesto".; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo  (Tercer procedimiento)',
                'urlAnexos' : `${ ligasipdus }34/N95/N95.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }34/N95/JAN95.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }34/N95/APN95.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }34/N95/FAN95.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 033
        'numConvocatoria' : 'Convocatoria No. 033/2026.',
        'idConvocatoria' : 'Convocatoria33',
        'procedimientos' : [
            // Licitación N94
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N94-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 14 de agosto de 2026',
                'descripcionProcedimiento' : 'Mantenimiento de Cuartel del Arte.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }33/N94/N94.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }33/N94/JAN94.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligasipdus }33/N94/APN94.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }33/N94/FAN94.pdf`,
                    //    },
                ],
            },
            // Licitación N93
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N93-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 14 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de la Casa de la Mujer Indígena 2da Etapa en el municipio de Atlapexco; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }33/N93/N93.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }33/N93/JAN93.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }33/N93/APN93.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }33/N93/FAN93.pdf`,
                       },
                ],
            },
            // Licitación N92
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N92-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 14 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico en la Región Huasteca, ubicado en la unidad deportiva Luis Donaldo Colosio Murrieta, municipio de San Felipe Orizatlán; ubicada en la localidad y Municipio de San Felipe Orizatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }33/N92/N92.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }33/N92/JAN92.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }33/N92/APN92.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }33/N92/FAN92.pdf`,
                       },
                ],
            },
            // Licitación N91
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N91-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 3 al 14 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de corredor artesanal y gastronómico ubicado en la cabecera municipal de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }33/N91/N91.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }33/N91/JAN91.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }33/N91/APN91.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }33/N91/FAN91.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 032
        'numConvocatoria' : 'Convocatoria No. 032/2026.',
        'idConvocatoria' : 'Convocatoria32',
        'procedimientos' : [
            // Licitación N90
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N90-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de julio al 10 de agosto de 2026',
                'descripcionProcedimiento' : 'Reconstrucción de la C.E. San Francisco - San Joaquín (tramo el mercader - San Joaquín), en el municipio de Tecozautla.; ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }32/N90/N90.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }32/N90/JAN90.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }32/N90/APN90.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }32/N90/FAN90.pdf`,
                       },
                ],
            },
            // Licitación N89
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N89-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de julio al 10 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico ubicado en la Región Otomí-Tepehua, ubicado en la Cabecera Municipal de Huehuetla.; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo (Segundo Procedimiento)',
                'urlAnexos' : `${ ligasipdus }32/N89/N89.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }32/N89/JAN89.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }32/N89/APN89.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }32/N89/FAN89.pdf`,
                       },
                ],
            },
            // Licitación N88
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N88-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de julio al 10 de agosto de 2026.',
                'descripcionProcedimiento' : 'Mejoramiento de Imagen Urbana en el Centro Histórico Atlapexco.; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }32/N88/N88.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }32/N88/JAN88.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }32/N88/APN88.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }32/N88/FAN88.pdf`,
                       },
                ],
            },
            // Licitación N87
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N87-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 27 de julio al 10 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción del nuevo taller de órtesis y prótesis en el municipio de Pachuca de Soto,Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }32/N87/N87.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }32/N87/JAN87.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }32/N87/APN87.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }32/N87/FAN87.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 031
        'numConvocatoria' : 'Convocatoria No. 031/2026.',
        'idConvocatoria' : 'Convocatoria31',
        'procedimientos' : [
            // Licitación N86
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N86-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 24 de julio de 2026',
                'descripcionProcedimiento' : 'Infraestructura complementaria del complejo "Hidalgo Honesto".; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo (Segundo procedimiento).',
                'urlAnexos' : `${ ligasipdus }31/N86/N86.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }31/N86/JAN86.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligasipdus }31/N86/APN86.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }31/N86/FAN86.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 030
        'numConvocatoria' : 'Convocatoria No. 030/2026.',
        'idConvocatoria' : 'Convocatoria30',
        'procedimientos' : [
            // Licitación N85
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N85-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Dr, Luis Ponce Romero, tramo calle José Ma. Bandera a Viaducto Javier Rojo Gómez, colonia Doctores, en municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }30/N85/N85.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }30/N85/JAN85.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }30/N85/APN85.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }30/N85/FAN85.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 029
        'numConvocatoria' : 'Convocatoria No. 029/2026.',
        'idConvocatoria' : 'Convocatoria29',
        'procedimientos' : [
            // Licitación N84
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N84-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Rio Alvarado colonia ampliación El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N84/N84.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N84/JAN84.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N84/APN84.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N84/FAN84.pdf`,
                       },
                ],
            },
            // Licitación N83
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N83-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle avenida 1 entre Av. Magisterio y Av. Insurgentes, colonia Piracantos, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N83/N83.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N83/JAN83.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N83/APN83.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N83/FAN83.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }29/N83/AMDFAN83.pdf`,
                    },
                ],
            },
            // Licitación N82
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N82-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en camino hacia el panteón, localidad de Palo Gordo, en el municipio de Metepec.; ubicada en la localidad de Palo Gordo (Ejido Nopalillo), Municipio de Metepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N82/N82.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N82/JAN82.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N82/APN82.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }29/N82/AMDAPN82.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N82/FAN82.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }29/N82/AMDFAN82.pdf`,
                    },
                ],
            },
            // Licitación N81
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N81-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026.',
                'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle principal de la comunidad de tlatepexe, en el municipio de Metztititlán.; ubicada en la localidad y Municipio de Metztitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N81/N81.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N81/JAN81.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N81/APN81.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N81/FAN81.pdf`,
                       },
                ],
            },
            // Licitación N80
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N80-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Felipe Ángeles colonia Cuauhtémoc, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N80/N80.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N80/JAN80.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N80/APN80.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N80/FAN80.pdf`,
                       },
                ],
            },
            // Licitación N79
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N79-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 de julio al 3 de agosto de 2026.',
                'descripcionProcedimiento' : 'Pavimento de concreto hidráulico en calle Jaime Nunó, colonia Periodistas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N79/N79.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N79/JAN79.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N79/APN79.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N79/FAN79.pdf`,
                       },
                ],
            },
            // Licitación N78
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N78-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en cale de acceso a la comunidad de Nopalillo, en el municipio de Metepec.; ubicada en la localidad de Nopalillo, Municipio de Metepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N78/N78.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N78/JAN78.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N78/APN78.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N78/FAN78.pdf`,
                       },
                ],
            },
            // Licitación N77
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N77-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en libramiento C. José Francisco Osorno, en el municipio de Apan.; ubicada en la localidad de Las Haciendas, Municipio de Apan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N77/N77.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N77/JAN77.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N77/APN77.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N77/FAN77.pdf`,
                       },
                ],
            },
            // Licitación N76
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N76-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la calle Begonia,colonia Progreso, en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N76/N76.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N76/JAN76.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N76/APN76.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N76/FAN76.pdf`,
                       },
                ],
            },
            // Licitación N75
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N75-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto Hidráulico en calle Gardenia colonia Jardines de colosio, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N75/N75.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N75/JAN75.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N75/APN75.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N75/FAN75.pdf`,
                       },
                ],
            },
            // Licitación N74
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N74-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Reconstrucción de la C. E. Tulancingo-Huasca (tramo Acatlán-Hacienda El Lucero), en el municipio de Acatlán.; ubicada en Varias localidades del Municipio de Acatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N74/N74.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N74/JAN74.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N74/APN74.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N74/FAN74.pdf`,
                       },
                ],
            },
            // Licitación N73
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N73-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación d concreto hidráulico en calle San Juan Pachuca, colonia centro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N73/N73.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N73/JAN73.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N73/APN73.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N73/FAN73.pdf`,
                       },
                ],
            },
            // Licitación N72
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N72-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Miguel Hidalgo, colonia Venta Prieta, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }29/N72/N72.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N72/JAN72.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }29/N72/AMDJAN72.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N72/APN72.pdf`,
                       },
                        {
                            'resultado' : 'Anexo modificatorio',
                            'urlresultado' : `${ ligasipdus }29/N72/AMDAPN72.pdf`,
                        },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N72/FAN72.pdf`,
                       },
                ],
            },
            // Licitación N71
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N71-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Reconstrucción de la carretera intermunicipal de Tolcayuca a Zapotlán de Juárez, en el municipio de Tolcayuca.; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N71/N71.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N71/JAN71.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N71/APN71.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N71/FAN71.pdf`,
                       },
                ],
            },
            // Licitación N70
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N70-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Modernización de carretera Tlaxcoapan-Apaxco (tramo San José Bojay-límites con Atotonilco de Tula) con concreto hidráulico, municipio de Atitalaquia.; ubicada en la localidad y Municipio de Atitalaquia, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N70/N70.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N70/JAN70.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N70/APN70.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N70/FAN70.pdf`,
                       },
                ],
            },
            // Licitación N69
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N69-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Modernización de carretera Tlaxcoapan-Apaxco (Texas-limites con Atitalaquia) con concreto hidráulico, en el municipio Atotonilco de Tula.; ubicada en la localidad de Texas, Municipio de Atotonilco de Tula, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N69/N69.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N69/JAN69.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N69/APN69.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }29/N69/AMDAPN69.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N69/FAN69.pdf`,
                       },
                ],
            },
            // Licitación N68
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N68-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Ampliación de la avenida constructores entronque boulevard Felipe Ángeles y boulevard Luis D. Colosio,en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N68/N68.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N68/JAN68.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N68/APN68.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N68/FAN68.pdf`,
                       },
                ],
            },
            // Licitación N67
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N67-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de calle de la Minería y boulevard Felipe Ángeles, Fomento Minero, en el Municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N67/N67.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N67/JAN67.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N67/APN67.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N67/FAN67.pdf`,
                       },
                ],
            },
            // Licitación N66
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N66-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 20 al 31 de julio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de jardín Colón en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }29/N66/N66.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }29/N66/JAN66.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }29/N66/APN66.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }29/N66/FAN66.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 028
        'numConvocatoria' : 'Convocatoria No. 028/2026.',
        'idConvocatoria' : 'Convocatoria28',
        'procedimientos' : [
            // Licitación N65
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N65-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de julio de 2026',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de San Felipe Orizatlán; ubicada en la localidad de Huextetitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }28/N65/N65.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }28/N65/JAN65.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }28/N65/APN65.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }28/N65/FAN65.pdf`,
                       },
                ],
            },
            // Licitación N64
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N64-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de julio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de Espacio de Atención Temporal en Huejutla de Reyes (2a etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }28/N64/N64.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }28/N64/JAN64.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }28/N64/APN64.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }28/N64/FAN64.pdf`,
                       },
                ],
            },
            // Licitación N63
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N63-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de julio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación del CGI Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }28/N63/N63.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }28/N63/JAN63.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }28/N63/APN63.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }28/N63/FAN63.pdf`,
                       },
                ],
            },
            // Licitación N62
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N62-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de julio de 2026.',
                'descripcionProcedimiento' : 'Terminación de pavimentación de concreto asfáltico en calle Campo de Tiro, colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }28/N62/N62.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }28/N62/JAN62.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }28/N62/APN62.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }28/N62/FAN62.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 027
        'numConvocatoria' : 'Convocatoria No. 027/2026.',
        'idConvocatoria' : 'Convocatoria27',
        'procedimientos' : [
            // Licitación N61
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N61-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de julio de 2026',
                'descripcionProcedimiento' : 'Remodelación de parque en la localidad de Llano Largo, municipio de Huichapan; ubicada en la localidad de Llano Largo, Municipio de Huichapan, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }27/N61/N61.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }27/N61/JAN61.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }27/N61/APN61.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }27/N61/FAN61.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }27/N61/AMDFAN61.pdf`,
                    },
                ],
            },
            // Licitación N60
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N60-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de julio de 2026.',
                'descripcionProcedimiento' : 'Remodelación de parque en la localidad de San José Bojay, municipio de Atitalaquia; ubicada en la localidad de San José Bojay el Grande, Municipio de Atitalaquia, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }27/N60/N60.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }27/N60/JAN60.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }27/N60/APN60.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }27/N60/FAN60.pdf`,
                       },
                ],
            },
            // Licitación N59
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N59-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico en la Región Otomí - Tepehua, ubicado en la Cabecera Municipal de Huehuetla; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }27/N59/N59.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }27/N59/JAN59.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Apertura',
                    //        'urlresultado' : `${ ligasipdus }27/N59/APN59.pdf`,
                    //    },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }27/N59/FAN59.pdf`,
                    //    },
                ],
            },
            // Licitación N58
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N58-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de julio de 2026.',
                'descripcionProcedimiento' : 'Mejoramiento de imagen urbana en el centro histórico San Agustín Metzquititlán; ubicada en la localidad de Metzquititlán, Municipio de San Agustín Metzquititlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }27/N58/N58.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }27/N58/JAN58.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }27/N58/APN58.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }27/N58/FAN58.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 026
        'numConvocatoria' : 'Convocatoria No. 026/2026.',
        'idConvocatoria' : 'Convocatoria26',
        'procedimientos' : [
            // Licitación N57
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N57-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 13 de julio de 2026',
                'descripcionProcedimiento' : 'Sustitución de barreras de concreto en C.E. Autopista Turística de la Montaña, Mineral de la Reforma.; ubicada en la localidad de San Guillermo la Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }26/N57/N57.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }26/N57/JAN57.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }26/N57/APN57.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }26/N57/FAN57.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 025
        'numConvocatoria' : 'Convocatoria No. 025/2026.',
        'idConvocatoria' : 'Convocatoria25',
        'procedimientos' : [
            // Licitación N56
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N56-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 13 de julio de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Carpintero Colonia Campo de Tiro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }25/N56/N56.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }25/N56/JAN56.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }25/N56/APN56.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }25/N56/FAN56.pdf`,
                       },
                ],
            },
            // Licitación N55
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N55-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 13 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico, en lateral del boulevard Felipe Ángeles (tramo Perisur - SEPH), en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }25/N55/N55.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }25/N55/JAN55.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }25/N55/APN55.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }25/N55/FAN55.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 024
        'numConvocatoria' : 'Convocatoria No. 024/2026.',
        'idConvocatoria' : 'Convocatoria24',
        'procedimientos' : [
            // Licitación N54
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N54-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 6 de julio de 2026',
                'descripcionProcedimiento' : 'Infraestructura complementaria del complejo "Hidalgo Honesto"; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }24/N54/N54.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }24/N54/JAN54.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }24/N54/APN54.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }24/N54/FAN54.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 023
        'numConvocatoria' : 'Convocatoria No. 023/2026.',
        'idConvocatoria' : 'Convocatoria23',
        'procedimientos' : [
            // Licitación N53
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N53-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026',
                'descripcionProcedimiento' : 'Remodelación de parque en comunidad indígena en la región Huasteca, ejido de Tecopia, localidad de Linda Vista, municipio de Xochiatipan.; ubicada en la localidad de Linda Vista, Municipio de Xochiatipan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }23/N53/N53.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N53/JAN53.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N53/APN53.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N53/FAN53.pdf`,
                       },
                ],
            },
            // Licitación N52
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N52-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de corredor artesanal y gastronómico en la Región Otomí - Tepehua, ubicado en El Predio La Zarzamora, Localidad de El Desdavi municipio de Tenango de Doria, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }23/N52/N52.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N52/JAN52.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N52/APN52.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N52/FAN52.pdf`,
                       },
                ],
            },
            // Licitación N51
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N51-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico en la región Huasteca, ubicado en la colonia Colalambre, municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }23/N51/N51.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N51/JAN51.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N51/APN51.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N51/FAN51.pdf`,
                       },
                ],
            },
            // Licitación N50
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N50-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026.',
                'descripcionProcedimiento' : 'Remodelación de parque en la unidad deportiva de Tepeji del Río; ubicada en la localidad y Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }23/N50/N50.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N50/JAN50.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }23/N50/AMDJAN50.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N50/APN50.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }23/N50/AMDAPN50.pdf`,
                    },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N50/FAN50.pdf`,
                       },
                ]
            },
            // Licitación N49
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N49-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026.',
                'descripcionProcedimiento' : 'Construcción de corredor artesanal y gastronómico en la región Valle del Mezquital, ubicado en la localidad de San Andrés Daboxtha, municipio de Cardonal, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }23/N49/N49.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N49/JAN49.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N49/APN49.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N49/FAN49.pdf`,
                       },
                ],
            },
            // Licitación N48
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N48-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 29 de junio al 10 de julio de 2026.',
                'descripcionProcedimiento' : 'Parador Turístico Cardonal (primera etapa).; ubicada en la localidad de El Molino, Municipio de Cardonal, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }23/N48/N48.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }23/N48/JAN48.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }23/N48/APN48.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }23/N48/FAN48.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 022
        'numConvocatoria' : 'Convocatoria No. 022/2026.',
        'idConvocatoria' : 'Convocatoria22',
        'procedimientos' : [
            // Licitación N47
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N47-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026',
                'descripcionProcedimiento' : 'Reconstrucción de C.E. Alfajayucan - Chapantongo - Tepetitlán, segunda etapa (paso por Tepetitlán), en el municipio de Tepetitlán.; ubicada en Varias localidades del Municipio de Tepetitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }22/N47/N47.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }22/N47/JAN47.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }22/N47/APN47.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }22/N47/FAN47.pdf`,
                       },
                ],
            },
            // Licitación N46
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N46-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en Calle Petirrojo Colonia Campo de Tiro, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }22/N46/N46.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }22/N46/JAN46.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }22/N46/APN46.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }22/N46/FAN46.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }22/N46/AMDFAN46.pdf`,
                    },
                ],
            },
            // Licitación N45
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N45-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de la carretera El Lindero a Honey (segunda etapa), en el municipio de Acaxochitlán.; ubicada en la localidad de San Pedro Tlachichilco, Municipio de Acaxochitlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }22/N45/N45.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }22/N45/JAN45.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }22/N45/APN45.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }22/N45/FAN45.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }22/N45/AMDFAN45.pdf`,
                    },
                ],
            },
            // Licitación N44
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N44-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Chamancipari en cuerpo izquierdo, tramo lateral boulevard Colosio a calle Insurgentes, colonia Piracantos, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }22/N44/N44.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }22/N44/JAN44.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }22/N44/APN44.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }22/N44/FAN44.pdf`,
                       },
                ],
            },
            // Licitación N43
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N43-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de sistema de agua potable en la localidad de Camposanto del Oro, en el municipio de Zimapán.; ubicada en la localidad de Camposanto del Oro, Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }22/N43/N43.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }22/N43/JAN43.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }22/N43/APN43.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }22/N43/FAN43.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 021
        'numConvocatoria' : 'Convocatoria No. 021/2026.',
        'idConvocatoria' : 'Convocatoria21',
        'procedimientos' : [
            // Licitación N42
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N42-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en boulevard Hacienda de Guadalupe fraccionamiento Pitahayas primer etapa, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }21/N42/N42.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }21/N42/JAN42.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }21/N42/APN42.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }21/N42/FAN42.pdf`,
                       },
                ],
            },
            // Licitación N41
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N41-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 de junio al 3 de julio de 2026.',
                'descripcionProcedimiento' : 'Terminación de pavimentación de concreto hidráulico en calle Antiguo Heroico Colegio Militar, colonia San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }21/N41/N41.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }21/N41/JAN41.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }21/N41/APN41.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }21/N41/FAN41.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 020
        'numConvocatoria' : 'Convocatoria No. 020/2026.',
        'idConvocatoria' : 'Convocatoria20',
        'procedimientos' : [
            // Licitación N40
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N40-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Puerto Progreso, colonia El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N40/N40.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N40/JAN40.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N40/APN40.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N40/FAN40.pdf`,
                       },
                ],
            },
            // Licitación N39
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N39-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Puerto Madero, colonia El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N39/N39.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N39/JAN39.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N39/APN39.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N39/FAN39.pdf`,
                       },
                ],
            },
            // Licitación N38
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N38-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI de Zimapán; ubicada en la localidad de , Municipio de Zimapán, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N38/N38.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N38/JAN38.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N38/APN38.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N38/FAN38.pdf`,
                       },
                ],
            },
            // Licitación N37
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N37-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de CGI Tenango de Doria; ubicada en la localidad y Municipio de Tenango de Doria, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N37/N37.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N37/JAN37.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N37/APN37.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N37/FAN37.pdf`,
                       },
                ],
            },
            // Licitación N36
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N36-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de Laboratorio Dental; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N36/N36.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N36/JAN36.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N36/APN36.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N36/FAN36.pdf`,
                       },
                ],
            },
            // Licitación N35
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N35-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 15 al 26 de junio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico Integral de Tlahuelilpan; ubicada en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }20/N35/N35.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }20/N35/JAN35.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }20/N35/APN35.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }20/N35/FAN35.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 019
        'numConvocatoria' : 'Convocatoria No. 019/2026.',
        'idConvocatoria' : 'Convocatoria19',
        'procedimientos' : [
            // Licitación N34
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N34-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 24 de junio de 2026',
                'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }19/N34/N34.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }19/N34/JAN34.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }19/N34/APN34.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }19/N34/FAN34.pdf`,
                       },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligasipdus }19/N34/AMDFAN34.pdf`,
                    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 018
        'numConvocatoria' : 'Convocatoria No. 018/2026.',
        'idConvocatoria' : 'Convocatoria18',
        'procedimientos' : [
            // Licitación N33
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N33-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 19 de junio de 2026',
                'descripcionProcedimiento' : 'Construcción del nuevo Salón de Plenos del Congreso de Estado de Hidalgo, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }18/N33/N33.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }18/N33/JAN33.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }18/N33/APN33.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }18/N33/FAN33.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 017
        'numConvocatoria' : 'Convocatoria No. 017/2026.',
        'idConvocatoria' : 'Convocatoria17',
        'procedimientos' : [
            // Licitación N32
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N32-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 8 al 19 de junio de 2026',
                'descripcionProcedimiento' : '"Rehabilitación general de sanitarios en oficinas centrales del sistema DIF Hidalgo, en Pachuca de Soto Hgo."; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }17/N32/N32.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }17/N32/JAN32.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }17/N32/APN32.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }17/N32/FAN32.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 016
        'numConvocatoria' : 'Convocatoria No. 016/2026.',
        'idConvocatoria' : 'Convocatoria16',
        'procedimientos' : [
            // Licitación N31
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N31-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 12 de junio de 2026',
                'descripcionProcedimiento' : 'Ampliación y rehabilitación de la avenida Tecnológico (tramo: ASEH - Fomento Minero) y construcción de acceso posterior al CASP, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }16/N31/N31.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }16/N31/JAN31.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }16/N31/APN31.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }16/N31/FAN31.pdf`,
                       },
                ],
            },
            // Licitación N30
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N30-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 1 al 12 de junio de 2026.',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle 16 de septiembre, colonia Periodistas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }16/N30/N30.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }16/N30/JAN30.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }16/N30/APN30.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }16/N30/FAN30.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 015
        'numConvocatoria' : 'Convocatoria No. 015/2026.',
        'idConvocatoria' : 'Convocatoria15',
        'procedimientos' : [
            // Licitación N29
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N29-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 25 de mayo al 5 de junio de 2026',
                'descripcionProcedimiento' : 'Rehabilitación de imagen urbana del boulevard Colosio, primera etapa, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }15/N29/N29.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }15/N29/JAN29.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }15/N29/APN29.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }15/N29/FAN29.pdf`,
                       },
                ],
            },
            // Licitación N28
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N28-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 25 de mayo al 5 de junio de 2026.',
                'descripcionProcedimiento' : 'Construcción y rehabilitación de espacios en el Centro de Rehabilitación Integral Regional Hidalgo (CRIRH), ubicado en el municipio de Ixmiquilpan.; ubicada en la localidad de EL TEPHÉ, Municipio de Ixmiquilpan, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }15/N28/N28.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }15/N28/JAN28.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }15/N28/APN28.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }15/N28/FAN28.pdf`,
                       },
                ],
            },
            // Licitación N27
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N27-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 25 de mayo al 5 de junio de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación integral de acceso principal y caseta de control de acceso a instalaciones del Sistema DIF Hidalgo, ubicado en Pachuca de Soto, Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligasipdus }15/N27/N27.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }15/N27/JAN27.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }15/N27/APN27.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }15/N27/FAN27.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 014
        'numConvocatoria' : 'Convocatoria No. 014/2026.',
        'idConvocatoria' : 'Convocatoria14',
        'procedimientos' : [
            // Licitación N26
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N26-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de mayo de 2026',
                'descripcionProcedimiento' : 'Reconstrucción de avenida Tecnológico de Monterrey, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }14/N26/N26.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }14/N26/JAN26.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }14/N26/APN26.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }14/N26/FAN26.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 013
        'numConvocatoria' : 'Convocatoria No. 013/2026.',
        'idConvocatoria' : 'Convocatoria13',
        'procedimientos' : [
            // Licitación N25
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N25-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de mayo de 2026',
                'descripcionProcedimiento' : 'Análisis, estudio y proyecto para obras de protección del Río Rosas, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }13/N25/N25.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }13/N25/JAN25.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }13/N25/APN25.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }13/N25/FAN25.pdf`,
                       },
                ],
            },
            // Licitación N24
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N24-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de mayo de 2026.',
                'descripcionProcedimiento' : 'Elaboración de estudio de socavación en Río Tula en tramo de colector revestido entre los km 3+400 - 3+800, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }13/N24/N24.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }13/N24/JAN24.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }13/N24/APN24.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }13/N24/FAN24.pdf`,
                       },
                ],
            },
            // Licitación N23
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N23-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 18 al 29 de mayo de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo.',
                'urlAnexos' : `${ ligasipdus }13/N23/N23.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligasipdus }13/N23/JAN23.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligasipdus }13/N23/APN23.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligasipdus }13/N23/FAN23.pdf`,
                    //    },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 012
        'numConvocatoria' : 'Convocatoria No. 012/2026.',
        'idConvocatoria' : 'Convocatoria12',
        'procedimientos' : [
            // Licitación N22
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N22-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de mayo de 2026',
                'descripcionProcedimiento' : 'Construcción de Techumbre de Pabellón Artesanal en las instalaciones de la Feria Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }12/N22/N22.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }12/N22/JAN22.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }12/N22/APN22.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }12/N22/FAN22.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 011
        'numConvocatoria' : 'Convocatoria No. 011/2026.',
        'idConvocatoria' : 'Convocatoria11',
        'procedimientos' : [
            // Licitación N21
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N21-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 15 de mayo de 2026',
                'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Puerto Peñasco, colonia El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }11/N21/N21.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }11/N21/JAN21.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }11/N21/APN21.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligasipdus }11/N21/FAN21.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 010
        'numConvocatoria' : 'Convocatoria No. 010/2026.',
        'idConvocatoria' : 'Convocatoria10',
        'procedimientos' : [
            // Licitación N20
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N20-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de mayo de 2026',
                'descripcionProcedimiento' : 'Rehabilitación punto de venta HIDARTE Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
                'urlAnexos' : `${ ligabase }10/N20/N20.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }10/N20/JAN20.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }10/N20/APN20.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }10/N20/FAN20.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 009
        'numConvocatoria' : 'Convocatoria No. 009/2026.',
        'idConvocatoria' : 'Convocatoria9',
        'procedimientos' : [
            // Licitación N19
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N19-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 22 al 28 de abril de 2026',
                'descripcionProcedimiento' : 'Reconstrucción del Boulevard Las Torres cuerpo derecho a base de concreto hidráulico, en el municipio de Pachuca de Soto.; de Cobertura Estatal',
                'urlAnexos' : `${ ligabase }9/N19/N19.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }9/N19/JAN19.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }9/N19/APN19.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }9/N19/FAN19.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 008
        'numConvocatoria' : 'Convocatoria No. 008/2026.',
        'idConvocatoria' : 'Convocatoria8',
        'procedimientos' : [
            // Licitación N18
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N18-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 13 al 24 de abril de 2026',
                'descripcionProcedimiento' : 'Ampliación de módulo del Tribunal Electoral del Estado de Hidalgo, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }8/N18/N18.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }8/N18/JAN18.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }8/N18/APN18.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }8/N18/FAN18.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 007
        'numConvocatoria' : 'Convocatoria No. 007/2026.',
        'idConvocatoria' : 'Convocatoria7',
        'procedimientos' : [
            // Licitación N17
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N17-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 6 al 17 de abril de 2026',
                'descripcionProcedimiento' : 'Rehabilitación punto de venta HIDARTE Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos' : `${ ligabase }7/N17/N17.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }7/N17/JAN17.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }7/N17/APN17.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }7/N17/FAN17.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 006
        'numConvocatoria' : 'Convocatoria No. 006/2026.',
        'idConvocatoria' : 'Convocatoria6',
        'procedimientos' : [
            // Licitación N16
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N16-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 30 de marzo al 10 de abril de 2026',
                'descripcionProcedimiento' : 'Obra complementaria para la construcción de Puente en camino de acceso principal a la localidad El Piñal, San Bartolo Tutotepec.; ubicada en la localidad de El Piñal, Municipio de San Bartolo Tutotepec, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }6/N16/N16.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }6/N16/JAN16.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }6/N16/APN16.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }6/N16/FAN16.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 005
        'numConvocatoria' : 'Convocatoria No. 005/2026.',
        'idConvocatoria' : 'Convocatoria5',
        'procedimientos' : [
            // Licitación N15
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N15-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 de marzo al 6 de abril de 2026',
                'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica en el Boulevard Colonias - Santa Catarina, segunda etapa,municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }5/N15/N15.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }5/N15/JAN15.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }5/N15/APN15.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }5/N15/FAN15.pdf`,
                       },
                ],
            },
            // Licitación N14
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N14-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 de marzo al 6 de abril de 2026.',
                'descripcionProcedimiento' : 'Construcción de Unidad Básica de Rehabilitación en la localidad de San Lorenzo Itztacoyotla, en el municipio de Juárez Hidalgo.; ubicada en la localidad de San Lorenzo Itztacoyotla, Municipio de Juárez Hidalgo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }5/N14/N14.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }5/N14/JAN14.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }5/N14/APN14.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }5/N14/FAN14.pdf`,
                       },
                ],
            },
            // Licitación N13
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N13-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 de marzo al 6 de abril de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de pavimento hidráulico, banquetas, guarniciones, alumbrado público, agua potable, drenaje sanitario en la Calle Heroico Colegio Militar, Colonia Centro, en el municipio de Tula de Allende.; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }5/N13/N13.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }5/N13/JAN13.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }5/N13/APN13.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }5/N13/FAN13.pdf`,
                       },
                ],
            },
            // Licitación N12
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N12-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 de marzo al 6 de abril de 2026.',
                'descripcionProcedimiento' : 'Construcción de Puente Nuevo Denominado La Romera, en el municipio de Tepeji del Río de Ocampo.; ubicada en la localidad de Tianguistengo (La Romera), Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }5/N12/N12.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }5/N12/JAN12.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }5/N12/APN12.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }5/N12/FAN12.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 004
        'numConvocatoria' : 'Convocatoria No. 004/2026.',
        'idConvocatoria' : 'Convocatoria4',
        'procedimientos' : [
            // Licitación N11
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N11-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 16 al 30 de marzo de 2026',
                'descripcionProcedimiento' : 'Construcción de puente vehicular en la localidad de Ohuatipa, en el municipio de Xochiatipan.; ubicada en la localidad de Ohuatipa, Municipio de Xochiatipan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }4/N11/N11.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }4/N11/JAN11.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }4/N11/APN11.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }4/N11/FAN11.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 003
        'numConvocatoria' : 'Convocatoria No. 003/2026.',
        'idConvocatoria' : 'Convocatoria3',
        'procedimientos' : [
            // Licitación N10
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N10-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2026',
                'descripcionProcedimiento' : 'Puesta en marcha del canal de interconexión entre la Presa El Yathé y la Presa Vicente Aguirre, en el municipio de Alfajayucan.; ubicada en la localidad y Municipio de Alfajayucan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }3/N10/N10.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }3/N10/JAN10.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }3/N10/APN10.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }3/N10/FAN10.pdf`,
                       },
                ],
            },
            // Licitación N9
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N9-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2026.',
                'descripcionProcedimiento' : 'Continuación de la construcción de pavimento de concreto hidráulico en acceso a cabecera de Tlahuiltepa.; ubicada en la localidad y Municipio de Tlahuiltepa, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }3/N9/N9.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }3/N9/JAN9.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }3/N9/APN9.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }3/N9/FAN9.pdf`,
                       },
                ],
            },
            // Licitación N8
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N8-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2026.',
                'descripcionProcedimiento' : 'Construcción de techumbre en espacio público multideportivo, en la colonia Parque de Poblamiento, localidad de Col. Parque de Poblamiento, municipio de Huejutla de Reyes.; ubicada en la localidad de Parque de Poblamiento Solidaridad, Municipio de Huejutla de Reyes, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }3/N8/N8.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }3/N8/JAN8.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }3/N8/APN8.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }3/N8/FAN8.pdf`,
                       },
                ],
            },
            // Licitación N7
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N7-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2026.',
                'descripcionProcedimiento' : 'Construcción de línea de conducción de agua potable de la localidad de Ixcuicuila, municipio de Molango de Escamilla.; ubicada en la localidad de Ixcuicuila, Municipio de Molango de Escamilla, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }3/N7/N7.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }3/N7/JAN7.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }3/N7/APN7.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }3/N7/FAN7.pdf`,
                       },
                ],
            },
            // Licitación N6
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N6-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 9 al 23 de marzo de 2026.',
                'descripcionProcedimiento' : 'Construcción de puente vehicular en la localidad de Tepetzintla II en el municipio de San Felipe Orizatlán.; ubicada en la localidad de Tepetzintla II, Municipio de San Felipe Orizatlán, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }3/N6/N6.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }3/N6/JAN6.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }3/N6/APN6.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }3/N6/FAN6.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 002
        'numConvocatoria' : 'Convocatoria No. 002/2026.',
        'idConvocatoria' : 'Convocatoria2',
        'procedimientos' : [
            // Licitación N5
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N5-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 2 al 13 de marzo de 2026',
                'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico de Av. Madero (Av. Juárez - Blvd. Río de las Avenidas), en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }2/N5/JAN5.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }2/N5/APN5.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }2/N5/FAN5.pdf`,
                       },
                ],
            },
            // Licitación N4
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N4-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 2 al 13 de marzo de 2026.',
                'descripcionProcedimiento' : 'Rehabilitación de la C.E. Atlapexco - Huejutla de Reyes del Km 8+500 al 18+360, en el municipio de Atlapexco.; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }2/N4/N4.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }2/N4/JAN4.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }2/N4/APN4.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }2/N4/FAN4.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 001
        'numConvocatoria' : 'Convocatoria No. 001/2026.',
        'idConvocatoria' : 'Convocatoria1',
        'procedimientos' : [
            // Licitación N3
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N3-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de febrero de 2026',
                'descripcionProcedimiento' : 'Pavimentación de camino rural tramo Piedras Negras a El Bopo, municipio de Tenango de Doria; ubicada en la localidad de El Bopo, Municipio de Tenango de Doria, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }1/N3/N3.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N3/JAN3.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N3/APN3.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N3/FAN3.pdf`,
                       },
                ],
            },
            // Licitación N2
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N2-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de febrero de 2026.',
                'descripcionProcedimiento' : 'Reposición del pozo 1, El Bojayito en el municipio de Tlaxcoapan, incluye perforación exploratoria a 200 metros, ampliación, filtro, ademe y colocación de equipo existente y puesta en operación.; ubicada en la localidad y Municipio de Tlaxcoapan, Estado de Hidalgo',
                'urlAnexos' : `${ ligabase }1/N2/N2.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N2/JAN2.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N2/APN2.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N2/FAN2.pdf`,
                       },
                ],
            },
            // Licitación N1
            {
                'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N1-2026.',
                'vigencia' : 'Vigencia de venta de bases: del 23 al 27 de febrero de 2026.',
                'descripcionProcedimiento' : 'Construcción de dos puentes colgantes sobre el Río Amajac en las localidades de Vado Hondo y San Andresito ubicados en los límites de los municipios de Jacala de Ledezma y Tlahuiltepa; de Cobertura Estatal',
                'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                       },
                ],
            },
        ],
    },
]